const wizard = {
  lot: {
    basicInfo: 'basicInfo',
    pointOfContacts: 'pointOfContacts',
    details: 'details',
    location: 'location',
    times: 'times',
    admin: 'admin',
  },
};

export default wizard;
